import { useAlertsInbox } from '../../api/hooks';
import AcademicDashboard from './AcademicDashboard';
import NeedsYouToday from './sections/NeedsYouToday';
import WrittenToMarkRow from './sections/WrittenToMarkRow';
import { useStudentLookup } from './sections/useStudentLookup';
import SetupBanner from '../../../pages/FirstLogin/SetupBanner';

export default function SchoolAdminDashboard() {
  const alerts = useAlertsInbox({});
  const students = useStudentLookup();
  return <AcademicDashboard title="School dashboard" aside={<div className="flex flex-col gap-[18px]"><SetupBanner /><WrittenToMarkRow /></div>}
    focus={<NeedsYouToday alerts={alerts.data?.results ?? []} students={students} />} />;
}
